module.exports = __webpack_public_path__ + "img/roles_1.b1a1e788.png";